const E = 250;
export {
  E as POPOVER_VISIBLE_DELAY
};
//# sourceMappingURL=constants.js.map
